import {
  Box,
  Stack,
  Typography,
  AvatarGroup,
  Avatar,
  Rating,
} from "@mui/material";

export const AuthSideImage = () => {
  return (
    <Box
      sx={{
        background:
          "url(/static/login-image.jpg) no-repeat center center / cover",
        flexGrow: 1,
        flexShrink: 1,
        height: "90%",
        borderTopLeftRadius: 20,
        borderBottomLeftRadius: 20,
      }}
    >
      <Stack
        justifyContent="end"
        alignItems="end"
        sx={{
          p: 2,
          px: 4,
          height: 1,
          background:
            "linear-gradient(to top,rgba(29, 28, 28, 0.69),transparent 95%)",
          borderTopLeftRadius: 20,
          borderBottomLeftRadius: 20,
        }}
        spacing={3}
      >
        <Stack
          sx={{
            p: 4,
          }}
          spacing={6}
        >
          <Stack spacing={1}>
            <Box sx={{ position: "relative", width: 70, pb: 4 }}>
              <img
                src="/static/login-circle.svg"
                alt="login circle"
                width={33}
                height={33}
                style={{
                  position: "absolute",
                  bottom: 15,
                  left: 20,
                  zIndex: 5,
                }}
              />
              <img
                src="/static/login-circle.svg"
                width={33}
                height={33}
                alt="login circle"
                style={{ position: "absolute", left: 10, zIndex: 10 }}
              />
              <img
                src="/static/login-circle.svg"
                width={33}
                height={33}
                alt="login circle"
                style={{ position: "absolute", right: 10, zIndex: 10 }}
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                color: "common.white",
              }}
            >
              Take charge of your <br /> Business
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: 13,
                fontWeight: 500,
                fontStyle: "italic",
                color: "common.white",
              }}
            >
              Log in or sign up to your Afritas (Afri-Home, Afri- pay,
              Afri-boat, Afri-stay, Afri-car Afri-ticket) . Vendor Dashboard to
              manage your listings, track bookings, update availability, accept
              payments, and grow your business with ease.
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
            <AvatarGroup max={4}>
              <Avatar
                alt="Login avatar 1"
                src="/static/avatar-1.jpg"
                sx={{ width: 30, height: 30 }}
              />
              <Avatar
                alt="Login avatar 2"
                src="/static/avatar-2.jpg"
                sx={{ width: 30, height: 30 }}
              />
              <Avatar
                alt="Login avatar 3"
                src="/static/avatar-3.jpg"
                sx={{ width: 30, height: 30 }}
              />
              <Avatar
                alt="Login avatar 4"
                src="/static/avatar-4.jpg"
                sx={{ width: 30, height: 30 }}
              />
            </AvatarGroup>
            <Stack>
              <Typography
                variant="body2"
                sx={{
                  color: "common.white",
                  fontSize: 13,
                  fontWeight: 500,
                }}
              >
                List. Manage. Grow.
              </Typography>
              <Rating size="small" name="list.manage" defaultValue={5} />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
